export default __webpack_public_path__ + "static/ProductGraphic1-68b30926e176225e1c7bfc3c1746c5b6.png";